import { AlgoliaCustomSort, ISearchProduct } from '@monofront/types';
import PaginatedHits from './PaginatedHits';

interface IInfiniteHitsProps {
  customSort?: AlgoliaCustomSort<ISearchProduct>;
}

const InfiniteHits: React.FC<IInfiniteHitsProps> = ({ customSort }) => (
  <PaginatedHits customSort={customSort} />
);

const CustomInfiniteHits = InfiniteHits;

export default CustomInfiniteHits;
